import React from "react"
import routes from "@Configs/routes/index"
import {Switch} from "react-router"
import RouterWithLayout from "./RouteWithLayout"
const AppRouter = ()=>{
    return <Switch>
    {
     routes.map(({page,layout,path,isPrivate,authenticatedRedirect,...rest},index)=>{
        return  <RouterWithLayout authenticatedRedirect={authenticatedRedirect} key={index} page ={page} layout={layout} path={path} isPrivate={isPrivate} {...rest} />
      }  
    )
}
    </Switch>
}
export default AppRouter;